import { API_URL } from "constants/ApiUrl";
import { useState, useEffect, useMemo } from "react";

export function useAgent() {
  const [agent, setAgent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function fetchAgentData() {
      setLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem("authUser");
        const res = await fetch(`${API_URL}/api/agent/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) {
          throw new Error(`Server error: ${res.status}`);
        }

        const data = await res.json();
        if (isMounted) setAgent(data);
      } catch (err) {
        if (isMounted) setError(err);
        console.error("useAgent:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchAgentData();

    return () => {
      isMounted = false;
    };
  }, []);

  const { activeSinceMonth, activeSinceYear } = useMemo(() => {
    if (!agent?.createdAt) {
      return { activeSinceMonth: null, activeSinceYear: null };
    }
    const date = new Date(agent.createdAt);
    return {
      activeSinceMonth: date.toLocaleString("default", { month: "long" }),
      activeSinceYear: date.getFullYear(),
    };
  }, [agent]);

  return {
    agent,
    loading,
    error,
    activeSinceMonth,
    activeSinceYear,
  };
}
